import { useEffect, useRef } from "react";

const AdBanner = () => {
  const adRef = useRef(false);

  useEffect(() => {
    if (!adRef.current) {
      adRef.current = true;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense error:", e);
      }
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-1373366134544796"
      data-ad-slot="4162384122"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdBanner;